// extracted by mini-css-extract-plugin
export default {"heartBeat":"Footer_heartBeat__QhZTo","beat-it":"Footer_beat-it__KzTuc"};